import { dataStamp } from 'dls-icons-data'
import { createIcon } from '../common'

const IconStamp = /*#__PURE__*/createIcon(dataStamp)
export default IconStamp
